'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _confirmDialog = require('./confirmDialog.html');

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _confirmDialog3 = require('./confirmDialog.controller');

var _confirmDialog4 = _interopRequireDefault(_confirmDialog3);

require('./confirmDialog.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var confirmDialogComponent = {
  bindings: {
    close: '&',
    dismiss: '&',
    resolve: '<'
  },
  template: _confirmDialog2.default,
  controller: _confirmDialog4.default,
  controllerAs: "vm"
};

exports.default = confirmDialogComponent;


// WEBPACK FOOTER //
// ./client/app/common/confirmDialog/confirmDialog.component.js